"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceTicket = exports.WorkflowStage = exports.FeedbackSentiment = exports.TicketSeverity = exports.TicketPriority = exports.TicketStatus = exports.TicketType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
const order_entity_1 = require("../orders/order.entity");
var TicketType;
(function (TicketType) {
    TicketType["LOGISTICS_NOT_RECEIVED"] = "logistics_not_received";
    TicketType["LOGISTICS_DAMAGED"] = "logistics_damaged";
    TicketType["SIDE_EFFECT"] = "side_effect";
    TicketType["NO_RESULT"] = "no_result";
    TicketType["REFUND_REQUEST"] = "refund_request";
    TicketType["RETURN_EXCHANGE"] = "return_exchange";
    TicketType["REGISTRATION_CANCEL"] = "registration_cancel";
    TicketType["FEEDBACK"] = "feedback";
    // Legacy / kept for existing data
    TicketType["LOGISTICS_FOLLOWUP"] = "logistics_followup";
    TicketType["DAMAGED_ORDER"] = "damaged_order";
    TicketType["CONSULTATION"] = "consultation";
    TicketType["GRIEVANCE"] = "grievance";
})(TicketType || (exports.TicketType = TicketType = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["OPEN"] = "open";
    TicketStatus["IN_PROGRESS"] = "in_progress";
    TicketStatus["WITH_DOCTOR"] = "with_doctor";
    TicketStatus["WITH_LOGISTICS"] = "with_logistics";
    TicketStatus["WITH_TEAM_LEAD"] = "with_team_lead";
    TicketStatus["WITH_MANAGEMENT"] = "with_management";
    TicketStatus["ESCALATED"] = "escalated";
    TicketStatus["RESOLVED"] = "resolved";
    TicketStatus["REFUNDED"] = "refunded";
    TicketStatus["CLOSED"] = "closed";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var TicketPriority;
(function (TicketPriority) {
    TicketPriority["LOW"] = "low";
    TicketPriority["NORMAL"] = "normal";
    TicketPriority["HIGH"] = "high";
    TicketPriority["URGENT"] = "urgent";
})(TicketPriority || (exports.TicketPriority = TicketPriority = {}));
var TicketSeverity;
(function (TicketSeverity) {
    TicketSeverity["MINOR"] = "minor";
    TicketSeverity["MAJOR_CRITICAL"] = "major_critical";
})(TicketSeverity || (exports.TicketSeverity = TicketSeverity = {}));
var FeedbackSentiment;
(function (FeedbackSentiment) {
    FeedbackSentiment["POSITIVE"] = "positive";
    FeedbackSentiment["NEGATIVE"] = "negative";
})(FeedbackSentiment || (exports.FeedbackSentiment = FeedbackSentiment = {}));
// Workflow stage — fine-grained step within the ticket's lifecycle
var WorkflowStage;
(function (WorkflowStage) {
    // Common
    WorkflowStage["OPEN"] = "open";
    // Logistics - not received
    WorkflowStage["CHECKING_ORDER"] = "checking_order";
    WorkflowStage["SHARED_LOGISTICS"] = "shared_logistics";
    // Logistics - damaged
    WorkflowStage["EVIDENCE_COLLECTED"] = "evidence_collected";
    WorkflowStage["VERIFYING_CLAIM"] = "verifying_claim";
    WorkflowStage["CLAIM_INVALID"] = "claim_invalid";
    // Side effect / No result / Refund (medicine)
    WorkflowStage["HISTORY_COLLECTED"] = "history_collected";
    WorkflowStage["WITH_DOCTOR"] = "with_doctor";
    // Refund / Return / Registration cancel
    WorkflowStage["WITH_TEAM_LEAD"] = "with_team_lead";
    WorkflowStage["WITH_MANAGEMENT"] = "with_management";
    // Feedback
    WorkflowStage["FORM_SHARED"] = "form_shared";
    WorkflowStage["FORM_FILLED"] = "form_filled";
    WorkflowStage["VIDEO_REQUESTED"] = "video_requested";
    // Logistics damaged
    WorkflowStage["EVIDENCE_LINK_SENT"] = "evidence_link_sent";
    // Terminal
    WorkflowStage["RESOLVED"] = "resolved";
    WorkflowStage["REFUNDED"] = "refunded";
    WorkflowStage["CLOSED"] = "closed";
})(WorkflowStage || (exports.WorkflowStage = WorkflowStage = {}));
let ServiceTicket = class ServiceTicket {
};
exports.ServiceTicket = ServiceTicket;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ServiceTicket.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Index)({ unique: true }),
    (0, typeorm_1.Column)({ length: 20 }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "ticketNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.tickets, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], ServiceTicket.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object)
], ServiceTicket.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object)
], ServiceTicket.prototype, "assignedTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => order_entity_1.Order, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof order_entity_1.Order !== "undefined" && order_entity_1.Order) === "function" ? _d : Object)
], ServiceTicket.prototype, "relatedOrder", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: TicketType }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "ticketType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: TicketStatus, default: TicketStatus.OPEN }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: TicketPriority, default: TicketPriority.NORMAL }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "priority", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: WorkflowStage, default: WorkflowStage.OPEN }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "workflowStage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: TicketSeverity, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "severity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: FeedbackSentiment, nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "feedbackSentiment", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], ServiceTicket.prototype, "feedbackFormShared", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], ServiceTicket.prototype, "feedbackFormFilled", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true, default: null, type: 'tinyint' }),
    tslib_1.__metadata("design:type", Object)
], ServiceTicket.prototype, "claimVerified", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text' }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", Array)
], ServiceTicket.prototype, "evidenceUrls", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], ServiceTicket.prototype, "doctorTeamSharedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], ServiceTicket.prototype, "escalatedToTeamLeadAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], ServiceTicket.prototype, "escalatedToManagementAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "doctorRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "teamLeadRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "managementRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], ServiceTicket.prototype, "finalRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, nullable: true }),
    tslib_1.__metadata("design:type", Number)
], ServiceTicket.prototype, "refundAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], ServiceTicket.prototype, "resolvedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], ServiceTicket.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], ServiceTicket.prototype, "updatedAt", void 0);
exports.ServiceTicket = ServiceTicket = tslib_1.__decorate([
    (0, typeorm_1.Entity)('service_tickets')
], ServiceTicket);
